import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Footer = () => {
  const { company, navItems, services } = useContent();
  return (
    <footer className="bg-[#1c1a17] text-[#cfc9bf]">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div>
            <span className="font-logo text-white text-[20px] tracking-[0.16em] block">
              FLETCHER &amp; STONE
            </span>
            <span className="font-body text-[#94664f] text-[10px] tracking-[0.4em] uppercase">
              Building Contractors
            </span>
            <p className="font-body text-[14px] leading-[1.9] text-[#a49e94] mt-6 max-w-[280px]">
              Traditional building contractors based in Tring, Hertfordshire, delivering fine residential work across {company.area}.
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-body uppercase tracking-[0.2em] text-[11px] text-white mb-6">Explore</h4>
            <ul className="space-y-3">
              {navItems.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="font-body text-[14px] text-[#a49e94] hover:text-[#94664f] transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-body uppercase tracking-[0.2em] text-[11px] text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="font-body text-[14px] text-[#a49e94] hover:text-[#94664f] transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body uppercase tracking-[0.2em] text-[11px] text-white mb-6">Contact</h4>
            <ul className="space-y-4 font-body text-[14px] text-[#a49e94]">
              <li className="flex gap-3"><Phone size={16} strokeWidth={1.4} className="text-[#94664f] mt-0.5 shrink-0" /><a href={`tel:${company.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">{company.phone}</a></li>
              <li className="flex gap-3"><Mail size={16} strokeWidth={1.4} className="text-[#94664f] mt-0.5 shrink-0" /><a href={`mailto:${company.email}`} className="hover:text-white transition-colors">{company.email}</a></li>
              <li className="flex gap-3"><Clock size={16} strokeWidth={1.4} className="text-[#94664f] mt-0.5 shrink-0" /><span>Mon&ndash;Fri, 8:00am&ndash;5:00pm</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#332f2a] mt-14 pt-8 flex flex-col md:flex-row justify-between gap-3">
          <p className="font-body text-[12px] text-[#7d766c]">
            &copy; {new Date().getFullYear()} {company.name} Building Contractors. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
